import * as home from './home'
import * as work from './work'
import * as about from './about'